<template>
  <svg version="1.1" viewBox="0 0 7529.57 4774.61" class="img-card" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2266561068528">
        <g>
          <image style="width:100%;" :href="typeCard" />
        </g>
      </g>
    </g>

    <text v-if="virtual" id="virtual" font-family="Roboto-Medium, Roboto" font-size="450" font-weight="800" :fill="cardColor">
      <tspan x="5500" y="700">{{ "Virtual" }}</tspan>
    </text>

    <text id="xxxx-xxxx-xxxx-xxxx-copy" font-family="Roboto-Medium, Roboto" font-size="350" font-weight="400" fill="#fff">
      <tspan x="300" y="2300">{{ cardPan }}</tspan>
    </text>
    <text id="Solde-:-295,23€" font-family="Roboto-Regular, Roboto" font-size="450" font-weight="normal" fill="#fff">
      <tspan id="solde" x="300" y="2900">
        {{ $t("title.soldLabel") }} {{ amountLeft }} lei
      </tspan>
    </text>
    <text id="Mathieu-Chabasse-Exp-Copy-2" font-family="Roboto-Regular, Roboto" font-size="300" font-weight="normal"
      fill="#fff">
      <tspan x="300" y="3700">{{ embossName }}</tspan>
      <tspan x="300" y="4100">
        {{ $t("title.expireAtLabel") }} {{ expireLabel }}
      </tspan>
    </text>
  </svg>
</template>

<script>
// import CardIcons11 from "../images/svg/card_up_icons_11.vue";
// import CardIcons12 from "../images/svg/card_up_icons_12.vue";
// import CardIcons13 from "../images/svg/card_up_icons_13.vue";
// import CardIcons14 from "../images/svg/card_up_icons_14.vue";
// import CardIcons1523 from "../images/svg/card_up_icons_1523.vue";

export default {
  components: {
    // CardIcons11,
    // CardIcons12,
    // CardIcons13,
    // CardIcons14,
    // CardIcons1523
  },
  props: {
    msg: String,
    amountLeft: {
      type: String,
      default: "0,00"
    },
    embossName: {
      type: String,
      default: "0"
    },
    expireLabel: {
      type: String,
      default: "0"
    },
    cardPan: {
      type: String,
      default: "0000 0000 0000 0000"
    },
    product: {
      type: Number,
      default: 14
    },
    virtual: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cardColor() {
      if (this.product === 11) {
        return "#F59100";
      } else if (this.product === 122) {
        return "#005C00";
      } else if (this.product === 123) {
        return "#c61b10";
      } else if (this.product === 13 || this.product === 134) {
        return "#FFCC08";
      } else {
        return "";
      }
    },
    typeCard() {
      let config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
      for (let index in config.cards) {
        if (config.cards[index].product === this.product) {
          return config.cards[index].image;
        }
      }

      return require("../../assets/images/logo-up-" + this.product + ".png");
    },
  }
};
</script>
<style scoped>
.fil1 {
  fill: #fefefe;
}

.fil4 {
  fill: #ffed00;
}

.fil10 {
  fill: white;
}

.fil0 {
  fill: #002b7f;
}

.fil2 {
  fill: #fefefe;
  fill-rule: nonzero;
}

.fil5 {
  fill: #2b2a29;
  fill-rule: nonzero;
}

.fil3 {
  fill: #264796;
  fill-rule: nonzero;
}

.fil7 {
  fill: #eb001b;
  fill-rule: nonzero;
}

.fil8 {
  fill: #f79e1b;
  fill-rule: nonzero;
}

.fil6 {
  fill: #ff5f00;
  fill-rule: nonzero;
}

.fil9 {
  fill: white;
  fill-rule: nonzero;
}

.img-card {
  width: 70% !important;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .img-card {
    width: 70% !important;
    height: 200px;
  }
}

@media (min-width: 1688px) {
  .img-card {
    width: 50% !important;
  }
}

@media (min-width: 1680px) {
  .img-card {
    width: 50% !important;
  }
}

@media (min-width: 1680px) and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .img-card {
    width: 50% !important;
  }
}
</style>
